export const theme = {
	colors: {
		primary: '#5F6403',
		secondary: '#DAFD2F',
		text: `#F8F1A1`,
		alert: '#d9534f',
		white: '#fff',
	},
};
